
// import { Footer } from 'element-ui'
import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)
export default new Router({
    routes: [
        {
            path: '/',
            name: 'home',
            components: {
                default: () => import('./views/home')
            },
            meta: { title: '报纸题名' }
        },
        {
            path: '/information',
            name: 'information',
            components: {
                default: () => import('./views/information')
            },
            meta: { title: '报纸卷号' }
        },
        {
            path: '/detail',
            name: 'detail',
            components: {
                default: () => import('./views/detail')
            },
            meta: { title: '报纸卷号详情' }
        },
        {
            path: '/search',
            name: 'search',
            components: {
                default: () => import('./views/search')
            },
            meta: { title: '搜索' }
        }
    ]
})